import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Divider, Text, Flex
} from 'components/ui';
import { colors, mediaQueries } from 'style/config';
import PaypalPill from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/Paypal/Paypal';
import Klarna from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/Klarna/Klarna';
import { AfterPayPill } from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/AfterPay';
import agentAwareUtils from 'utils/AgentAware';

const AlternatePaymentButtons = ({
    isAfterpayEnabledForThisOrder,
    isKlarnaEnabledForThisOrder,
    isPayPalEnabled,
    isPayPalPayLaterEligible,
    isAfterpayEnabledForThisProfile,
    installmentValue,
    localization,
    handleAfterPayExpand,
    handleKlarnaExpand,
    handlePayPalClick,
    giftCardAmountEqualsOrderTotal = false
}) => {
    // PayPal button only shows when enabled AND order >= $30 (isPayPalPayLaterEligible)
    // For orders < $30, PayPal is hidden on L1 (existing users with saved cards)
    const showPayPal = isPayPalEnabled && isPayPalPayLaterEligible && !giftCardAmountEqualsOrderTotal;

    // Show installment text if any installment payment method is available
    const showInstallmentText = isPayPalPayLaterEligible || isKlarnaEnabledForThisOrder || isAfterpayEnabledForThisOrder;

    const hasAnyPaymentButton = showPayPal || isKlarnaEnabledForThisOrder || isAfterpayEnabledForThisOrder;

    // Dont show the below section at all if there are no alternate payment buttons to show, to avoid unnecessary divider and spacing
    if (!hasAnyPaymentButton) {
        return null;
    }

    return (
        <Box className={agentAwareUtils.applyHideAgentAwareClass()}>
            <Divider marginY={4} />
            <Box paddingX={[4, 5]}>
                {showInstallmentText && (
                    <Text
                        is='p'
                        color={colors.gray}
                        marginBottom={1}
                        fontSize='sm'
                    >
                        {`${localization.orPayInFour} ${installmentValue}`}
                    </Text>
                )}

                {/* Payment buttons */}
                <Flex
                    gap={2}
                    marginBottom={4}
                    css={{ [mediaQueries.xsMax]: { '& > *': { flex: 1 } } }}
                >
                    <PaypalPill
                        isPayPalEnabled={showPayPal}
                        handlePaymentClick={handlePayPalClick}
                        height={32}
                        width={98}
                        imageScale={1.5}
                    />
                    <Klarna
                        isKlarnaEnabledForThisOrder={isKlarnaEnabledForThisOrder}
                        handlePaymentClick={handleKlarnaExpand}
                        height={32}
                        width={showPayPal ? 98 : 151}
                    />
                    <AfterPayPill
                        isAfterpayEnabledForThisOrder={isAfterpayEnabledForThisOrder}
                        isAfterpayEnabledForThisProfile={isAfterpayEnabledForThisProfile}
                        handleAfterPayExpand={handleAfterPayExpand}
                        height={32}
                        width={showPayPal ? 98 : 151}
                        imageHeight={16}
                    />
                </Flex>
            </Box>
        </Box>
    );
};

export default wrapFunctionalComponent(AlternatePaymentButtons, 'AlternatePaymentButtons');
